<template>
  <div class="relative text-gray-600 focus-within:text-gray-400 w-full">
    <label-form v-if="label" :text="label" />

    <input
          name="text-field"
          class="
              w-full px-2 flex border border-solid border-black
              rounded-md focus:outline-none focus:bg-white focus:text-gray-900
              text-sm
          "
          :disabled="disabled"
          autocomplete="off"
          :type="type"
          :maxlength="maxLength"
          :class="[`h-${height}`]"
          :value="value"
          :placeholder="placeholder"
          @input="$emit('input', $event.target.value)"
      >
  </div>
</template>

<script>
import eventBus from "/resources/js/Layouts/eventBus.vue";
import LabelForm from './Label'

export default {
    components: {
      LabelForm
    },
    props: {
        value: String,
        type: {
            type: String,
            default: 'text'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: 1000
        },
        label: {
          type: String,
          default: ''
        },
        height: {
            type: String,
            default: '10'
        },
        placeholder: {
            type: String,
            default: 'Buscar'
        },
    },
    created() {
        eventBus.$on("clearFilter", () => {
            this.$emit('input', null);
        });
    }
}
</script>

<style>
[name="text-field"]:disabled {
    background-color: rgb(230, 230, 230);
}
</style>
